// extracted by mini-css-extract-plugin
export var angledContainer__svgBox = "Containers-module--angledContainer__svgBox--82b70";
export var angled_container = "Containers-module--angled_container--2daab";
export var basesvg = "Containers-module--basesvg--baeed";
export var btmBorder = "Containers-module--btmBorder--a0380";
export var btmTrim = "Containers-module--btmTrim--ec387";
export var contained = "Containers-module--contained--11d96";
export var containerWrap = "Containers-module--containerWrap--d4c8d";
export var contentWrap = "Containers-module--contentWrap--9c582";
export var darkNavy = "Containers-module--darkNavy--9d265";
export var fullWidth = "Containers-module--fullWidth--26694";
export var gray = "Containers-module--gray--415d3";
export var graySVG = "Containers-module--graySVG--82025";
export var grayToNavySVG = "Containers-module--grayToNavySVG--89f06";
export var grayToNavySVGWrap = "Containers-module--grayToNavySVGWrap--345fd";
export var grayTrimToNavySVG = "Containers-module--grayTrimToNavySVG--4ed0b";
export var grayTrimToNavySVGWrap = "Containers-module--grayTrimToNavySVGWrap--5b9bf";
export var narrow = "Containers-module--narrow--0ab95";
export var navy = "Containers-module--navy--64d48";
export var navySVG = "Containers-module--navySVG--d5f57";
export var pressedEdgeLeft = "Containers-module--pressedEdgeLeft--f8d6d";
export var pressedEdgeRight = "Containers-module--pressedEdgeRight--2d735";
export var topBorder = "Containers-module--topBorder--85eb7";
export var twoToneContainer = "Containers-module--twoToneContainer--abfe1";
export var white = "Containers-module--white--af07c";